import React from 'react';
import { Link } from 'react-router-dom';
import { FadeIn } from './FadeIn';
import { CheckCircle2, Leaf, Heart, Sparkles } from 'lucide-react';
export function WorkWithMe() {
  const offers = [{
    title: 'Cum îți gestionezi emoțiile copleșitoare',
    subtitle: 'Mini-curs online',
    icon: Sparkles,
    image: 'https://cdn.magicpatterns.com/uploads/34kB1rguyriUqrZ9ZF82yj/anima_healing_academy_hero.jpg',
    benefits: ['5 audio-uri ghidate pentru reglare emoțională', 'Workbook PDF de 13 pagini', 'Fișa „Momentul Cicatricii"', 'Kitul de urgență emoțională', 'Acces pe viață la toate materialele'],
    ctaText: 'Descoperă Cursul',
    ctaLink: '/aha',
    isDark: false
  }, {
    title: 'ANIMA Recode',
    subtitle: 'Program de Transformare (9 luni)',
    icon: Leaf,
    image: 'https://cdn.magicpatterns.com/uploads/vpA5XLsZA8NiouiGoUZh1w/anima_recode_hero.jpg',
    benefits: ['9 module ghidate de transformare profundă', 'Workshop-uri live de grup o dată pe lună', 'Materiale practice și exerciții de aplicare', 'Acces la comunitate și suport continuu', 'Integrare NLP, constelații și coaching profund'],
    ctaText: 'Descoperă Programul',
    ctaLink: '/animarecode',
    isDark: true,
    isFeatured: true
  }, {
    title: 'Coaching 1 la 1',
    subtitle: 'Sesiuni Individuale Personalizate',
    icon: Heart,
    image: 'https://cdn.magicpatterns.com/uploads/4jJnQjtiPNiubtH5dxzgfZ/coaching_1la1_hero.jpg',
    benefits: ['Sesiune personalizată pe nevoile tale', 'Combinație de NLP, coaching și hipnoză', 'Lucru profund pe blocaje specifice', 'Plan de acțiune concret după fiecare sesiune', 'Flexibilitate în programare și ritm de lucru'],
    ctaText: 'Află Mai Multe',
    ctaLink: '/sesiune1la1',
    isDark: false
  }];
  return <section className="py-20 md:py-28 bg-ivory overflow-hidden relative" id="programe" data-id="element-786">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none -z-0" data-id="element-787">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-gold/5 rounded-full blur-3xl" data-id="element-788"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-forest/5 rounded-full blur-3xl" data-id="element-789"></div>
      </div>

      <div className="max-w-[1200px] mx-auto px-6 md:px-8 relative z-10" data-id="element-790">
        <div className="text-center max-w-[800px] mx-auto mb-16" data-id="element-791">
          <FadeIn data-id="element-792">
            <span className="inline-block font-display text-xs font-semibold tracking-[0.3em] text-gold-dark uppercase mb-4" data-id="element-793">
              Programele mele
            </span>
            <h2 className="text-4xl md:text-5xl font-serif font-medium text-charcoal mb-4" data-id="element-794">
              Alege cum vrei să lucrezi cu mine
            </h2>
            <p className="text-[19px] text-charcoal/70 font-sans" data-id="element-795">
              Trei căi diferite, aceeași destinație: tu, aliniată cu tine.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 items-stretch" data-id="element-796">
          {offers.map((offer, index) => {
          const Icon = offer.icon;
          return <FadeIn key={index} delay={index * 0.1} className="h-full" data-id="element-797">
                <div className={`h-full flex flex-col rounded-[32px] overflow-hidden transition-all duration-500 hover:-translate-y-2 relative ${offer.isDark ? 'bg-forest text-ivory shadow-2xl lg:scale-[1.04] hover:lg:scale-[1.06]' : 'bg-white text-charcoal shadow-soft border border-forest/10 hover:shadow-xl'}`} data-id="element-798">
                  {/* Featured badge */}
                  {offer.isFeatured && <div className="absolute top-6 right-6 z-20" data-id="element-799">
                      <div className="bg-gold text-forest font-display text-[10px] font-bold tracking-widest uppercase px-3 py-1.5 rounded-full shadow-md" data-id="element-800">
                        ★ Recomandat
                      </div>
                    </div>}

                  {/* Decorative glow for featured */}
                  {offer.isDark && <div className="absolute top-0 right-0 w-48 h-48 bg-gold/10 rounded-full blur-3xl pointer-events-none" data-id="element-801"></div>}

                  {/* Card Image */}
                  <div className="relative h-[180px] md:h-[200px] overflow-hidden m-4 rounded-[24px]" data-id="element-802">
                    <img src={offer.image} alt={offer.title} className="w-full h-full object-cover transition-transform duration-700 hover:scale-110" data-id="element-803" />
                    <div className={`absolute inset-0 ${offer.isDark ? 'bg-gradient-to-t from-forest/40 to-transparent' : 'bg-gradient-to-t from-black/10 to-transparent'}`} data-id="element-804"></div>
                  </div>

                  {/* Card Content */}
                  <div className="flex-grow flex flex-col p-7 pt-4 items-center text-center relative z-10" data-id="element-805">
                    <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-5 ${offer.isDark ? 'bg-gold/20 text-gold' : 'bg-forest/5 text-forest'}`} data-id="element-806">
                      <Icon className="w-5 h-5" data-id="element-807" />
                    </div>

                    <h3 className={`text-2xl md:text-[26px] font-serif font-medium mb-2 leading-tight ${offer.isDark ? 'text-ivory' : 'text-forest'}`} data-id="element-808">
                      {offer.title}
                    </h3>
                    <p className={`text-[15px] font-display tracking-wide mb-6 pb-5 border-b w-full ${offer.isDark ? 'text-gold/80 border-ivory/15' : 'text-charcoal/60 border-forest/10'}`} data-id="element-809">
                      {offer.subtitle}
                    </p>

                    <ul className="space-y-3.5 mb-8 flex-grow w-full text-left" data-id="element-810">
                      {offer.benefits.map((benefit, i) => <li key={i} className="flex items-start gap-3" data-id="element-811">
                          <div className={`mt-0.5 rounded-full p-0.5 shrink-0 ${offer.isDark ? 'bg-gold/20' : 'bg-gold/15'}`} data-id="element-812">
                            <CheckCircle2 className={`w-4 h-4 ${offer.isDark ? 'text-gold' : 'text-gold-dark'}`} strokeWidth={2.5} data-id="element-813" />
                          </div>
                          <span className={`text-[15px] leading-relaxed ${offer.isDark ? 'text-ivory/90' : 'text-charcoal/80'}`} data-id="element-814">
                            {benefit}
                          </span>
                        </li>)}
                    </ul>

                    <div className="mt-auto w-full" data-id="element-815">
                      <Link to={offer.ctaLink} className={`w-full inline-flex items-center justify-center px-6 py-3.5 rounded-full font-display font-medium text-[15px] transition-all duration-300 text-center no-underline ${offer.isDark ? 'bg-gold text-forest hover:bg-gold-dark' : 'bg-forest text-ivory hover:bg-forest-light'}`} data-id="element-816">
                        {offer.ctaText}
                      </Link>
                    </div>
                  </div>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}